'use strict';

angular.module('TurneroApp').service('appExternaService', ['$resource', 'portal', function ($resource, portal) {
	return $resource(portal.getUrlServer() + 'api/AppExterna/:id', { id: '@Id_Aplicacion' }, {
		Traer_Formulario: {
			method: 'GET',
			params: {
				Id_Agenda: '@Id_Agenda',
				Id_Tramite_Relevado: '@Id_Tramite_Relevado'
			},
			url: portal.getUrlServer() + 'api/AppExterna/Traer_Formulario/'
		},
		Traer_URL_Aplicacion_Ext: {
			method: 'GET',
			params: {
				Id_Tramite_Aplicacion: '@Id_Tramite_Aplicacion'
			},
			url: portal.getUrlServer() + 'api/AppExterna/Traer_URL_Aplicacion_Ext/'
		}

	});
}]);



// WEBPACK FOOTER //
// ./app/components/appExterna/appExterna-service.js